// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"1d99f462","239":"f49735dd","293":"73a970e8","455":"4504054e","977":"bd409b96"}[chunkId] + ".chunk.js";
};